module.exports = __webpack_public_path__ + "static/TruenoExBd-97e65141b77ac87bea2683567ab6c5c9.woff2";